// extracted by mini-css-extract-plugin
export default {"label":"SingleDatePicker__label--ufSPC","error":"SingleDatePicker__error--239TA","wrap":"SingleDatePicker__wrap--Hqdst","wrapMonth":"SingleDatePicker__wrapMonth--qenww"};